// extracted by mini-css-extract-plugin
export default {"downloadButton":"DownloadButton_downloadButton__x7dc6","black":"DownloadButton_black__RGKo9","buttonImage":"DownloadButton_buttonImage__IuiqP","text":"DownloadButton_text__kGBMU"};